import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';


import moment from 'moment';

import { Order } from 'models';
import { validate } from 'models/validate';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS } = helpers;

import DatePicker from 'react-datepicker';

import PlusIcon from '../../assets/icons/plus';

import { OrderSection } from 'components/PanelSections';

import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';
import EmptyArea from 'components/EmptyArea/EmptyArea';
import OrderProductItem from 'components/OrderProductItem/OrderProductItem';

import Input from './Input';
import ProductListPanel from './ProductListPanel';

import { keyedObjToArr, setObjPath, getOrderPrice, formatPrice, formatValue, getDateToTimestamp, getTimestampToDate} from '../util';

import 'react-datepicker/dist/react-datepicker.css';
import 'sass/components/custom-react-datepicker';
import 'components/OrderSection/order-section';

class OrderPanel extends Component {

	constructor (props) {
		super(props);
		let order = this.props.order;
		if(order.products) {
			order.products = keyedObjToArr(order.products);
		}

		this.state = {
			order : order,
			showProductOptions : false
		};
	}

	updateOrder (event) {

		let value = formatValue(event.target.value, event.target.type);
		let order = setObjPath(this.state.order, event.target.name, value);

		order = Object.assign(order, getOrderPrice(order));

		this.setState({
			order: order
		});
	}

	updateOrderCustomer (option) {
		let order = this.state.order;
		order.customer = option.value;
		this.setState({
			order : order
		});
	}
	//Create new Customer

	//For Methods below(swap out view within panel / don't create new panel)

	showProductOptions () {
		this.setState({
			showProductOptions : true
		});
	}

	hideProductOptions () {
		this.setState({
			showProductOptions : false
		});
	}

	addProducts (products, selected) {

		this.hideProductOptions();
		let order = this.state.order;

		order.products = products.filter( (product)=> {
			product.discount = product.discount || 0;
			return selected.includes(product.id);
		});

		order = Object.assign(order, getOrderPrice(order));

		this.setState({
			order:order
		});
	}

	//Edit Product

	//Edit Terms

	updateOrderStartDate(date) {
		let order = this.state.order;
		order.startDate = getDateToTimestamp(date);
			this.setState({
			order:order
		});
	}


	updateOrderEndDate(date) {
		let order = this.state.order;
		order.endDate = getDateToTimestamp(date);
		this.setState({
			order:order
		});
	}

	componentWillReceiveProps(nextProps) {
		let order = nextProps.order;
		if(order.products && !Array.isArray(order.products)) {
			order.products = keyedObjToArr(order.products);
		}
		this.setState({
			order : order
		});
	}

	render () {
		if(!isLoaded(this.props.products) || !isLoaded(this.props.customers)) {
			return false;
		}

		let customerOptions = keyedObjToArr(this.props.customers).map( (customer) => {
			return {label : customer.name, value : customer.id};
		});

		let productOptions = keyedObjToArr(this.props.products);

		if(this.state.showProductOptions){
			return (
				<ProductListPanel
					products={productOptions}
					order={this.state.order}
					closeDrawer={this.props.closeDrawer}
					hideProductOptions={this.hideProductOptions.bind(this)}
					addProducts={this.addProducts.bind(this)}
				/>
			);
		}

		let statusOptions = [
			{label : 'New', value : 'new'},
			{label : 'Pending', value : 'pending'},
			{label : 'Active', value : 'active'},
			{label : 'Expired', value : 'expired'},
			{label : 'Trial', value: 'trial'}
		];

		return (
			<div className="panel full">
				<ContentHeader
					title={this.props.editing ? 'Edit Order' : 'Create Order'}
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">
						{/* Title */}
						<OrderSection label="Order Title">
							<Input
								inputClass="input"
								placeholder="Order Title"
								name="title"
								value={this.state.order.title || ''}
								onChange={this.updateOrder.bind(this)}
							/>
						</OrderSection>

						{/* Customer */}
						<OrderSection label="Customer">
							<Input
								type="typeahead"
								inputClass="input"
								placeholder="Customer"
								name="customer"
								value={this.state.order.customer}
								onChange={this.updateOrderCustomer.bind(this)}
								options={customerOptions}
							/>
						</OrderSection>

						{/* Status */}
						<OrderSection label="Status">
							<Input
								type="select"
								inputClass="input"
								name="status"
								placeholder="Status"
								value={this.state.order.status}
								onChange={this.updateOrder.bind(this)}
								options={statusOptions}
							/>
						</OrderSection>

						{/* Duration */}
						<OrderSection label="Duration">
							<div className="row tight">
								<div className="col-6">
									<label className="input-label">Start Date</label>
									<DatePicker
										selected={getTimestampToDate(this.state.order.startDate)}
										onChange={this.updateOrderStartDate.bind(this)}
									/>
								</div>
								<div className="col-6">
									<label className="input-label">End Date</label>
									<DatePicker
										selected={getTimestampToDate(this.state.order.endDate)}
										popoverAttachment="top right"
										popoverTargetAttachment="bottom right"
										popoverTargetOffset="10px 16px"
										onChange={this.updateOrderEndDate.bind(this)}
									/>
								</div>
							</div>
						</OrderSection>

						{/* Products */}
						<OrderSection label="Products">
							{this.state.order.products ? (
								<ul className="product-order-list">
									{this.state.order.products.map( (product, index)=>{
										return(<li key={index}>
											<OrderProductItem
												showProductOptions={this.showProductOptions.bind(this)}
												{...product}
											/>
										</li>);
									})}
									<li key="subtotal" className="line-item">
										<div className="row">
											<div className="col-6">Subtotal</div>
											<div className="col-6 amount align-right">{formatPrice(this.state.order.subtotal)}</div>
										</div>
									</li>
									<li key="discount" className="line-item">
										<div className="row">
											<div className="col-6">Discount</div>
											<div className="col-6 amount align-right">
												<Input
													name="discount"
													value={this.state.order.discount || ''}
													type="number"
													onChange={this.updateOrder.bind(this)}
													placeholder="$0.00"
												/>
											</div>
										</div>
									</li>
									<li key="tax" className="line-item">
										<div className="row">
											<div className="col-6">Tax</div>
											<div className="col-6 amount align-right">{formatPrice(this.state.order.tax)}</div>
										</div>
									</li>
									<li key="total" className="line-item total">
										<div className="row">
											<div className="col-6">Total</div>
											<div className="col-6 amount align-right">{formatPrice(this.state.order.total)}</div>
										</div>
									</li>
								</ul>
							) : (

								<EmptyArea
									icon={PlusIcon}
									label="Add Product"
									onClick={this.showProductOptions.bind(this)}
								/>
							)}
						</OrderSection>

						{/* Terms */}
						{/*<OrderSection label="Terms">
							<div className="light-text-color small">
								TODO
							</div>
						</OrderSection>*/}
					</div>
				</div>
				<ContentFooter
					onClose={this.props.closeDrawer}
					onCancel={this.props.onCancel}
					onConfirm={function () {

						validate(this.state.order, Order).then( (validatedOrder)=> {
							if(this.props.editing) {
								this.props.saveOrder(validatedOrder);
								this.props.addNotification('add-save-order-success-' + Date.now(), 'Order Saved');
							} else {
								this.props.addOrder(validatedOrder);
								this.props.addNotification('add-save-order-success-' + Date.now(), 'Order Added');
								this.props.closeDrawer();
							}

						}).catch( (error)=> {
							console.log(error.message);
							this.props.addNotification('add-save-order-error-' + Date.now(), error.message);
						});

					}.bind(this)}
					cancelLabel={this.props.cancelLabel}
					confirmLabel='Save Order'
				/>
		</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

const fbWrappedComponent = firebaseConnect([
	'/customers',
	'/products'
])(OrderPanel);

//Need list of all Customers for Options
//Need list of all Products for Options
//Need Settings / Terms

export default connect(
	({ firebase }) => ({
		customers: dataToJS(firebase, 'customers'),
		products: dataToJS(firebase, 'products')
	}),
	mapDispatchToProps
)(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/components/OrderPanel.js